/** Предел длины запомненного вкладкой и введённого в поиск текста (наименование, штрихкод, артикул). */
export const MAX_SEARCH_TEXT_LENGTH = 500

/** Предел длины значения поля черновика карточки (наименование, артикул, штрихкод). */
export const MAX_FIELD_VALUE_LENGTH = 1000

/** Сколько строк просит проверяющее чтение ревизии по наименованию: нужна только ревизия, не список. */
export const VERSION_PROBE_LIMIT = 5
